
const digest = '84ae1ceb19012fbfacbf84c77cea475116120eddd96dd4d79d7a8ec3616feed3';
const classes = {"item":"_item_1u33y_1","checkWrapper":"_checkWrapper_1u33y_10","content":"_content_1u33y_13","medicament":"_medicament_1u33y_22","title":"_title_1u33y_27","moreInfo":"_moreInfo_1u33y_34","moreInfoItem":"_moreInfoItem_1u33y_41","text":"_text_1u33y_50","controls":"_controls_1u33y_53","link":"_link_1u33y_64"};
const css = `._item_1u33y_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  width: 100%;
  border: 1px solid #eaedf3;
  border-top: 0;
  background: #ffffff;
}
._item_1u33y_1 ._checkWrapper_1u33y_10 {
  padding: 24px 0 24px 24px;
}
._item_1u33y_1 ._content_1u33y_13 {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  font-size: 16px;
  color: #000000;
  padding: 24px;
}
._item_1u33y_1 ._content_1u33y_13 ._medicament_1u33y_22 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
._item_1u33y_1 ._content_1u33y_13 ._medicament_1u33y_22 ._title_1u33y_27 {
  font-weight: 500;
  min-width: 255px;
}
._item_1u33y_1 ._content_1u33y_13 ._medicament_1u33y_22 ._title_1u33y_27 span {
  font-weight: 400;
}
._item_1u33y_1 ._content_1u33y_13 ._moreInfo_1u33y_34 {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-bottom: 10px;
  flex-wrap: wrap;
}
._item_1u33y_1 ._content_1u33y_13 ._moreInfo_1u33y_34 ._moreInfoItem_1u33y_41 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._item_1u33y_1 ._content_1u33y_13 ._moreInfo_1u33y_34 ._moreInfoItem_1u33y_41 ._title_1u33y_27 {
  color: grey;
}
._item_1u33y_1 ._content_1u33y_13 ._moreInfo_1u33y_34 ._moreInfoItem_1u33y_41 ._text_1u33y_50 {
  color: #000000;
}
._item_1u33y_1 ._controls_1u33y_53 {
  min-width: 200px;
  max-width: 200px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 16px;
}
._item_1u33y_1 ._controls_1u33y_53 ._link_1u33y_64 {
  font-size: 14px;
  font-weight: 500;
  color: #1665d8;
  text-decoration: underline;
  cursor: pointer;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  